<template>
	<div class="search_bar">
		<v-text-field
			class="search-input"
			label="Search products by name..."
			prepend-inner-icon="search"
			outlined
			solo
			flat
			@input="onChange"
			:height="50"
			hide-details
			color="#18125a"
			clearable
		></v-text-field>
	</div>
</template>


<script>
export default {
	name: "SearchBar",
	props: {
		value: String
	},
	data: () => {
		return {
			timeout: null
		};
	},
	methods: {
		onChange(event) {
			clearTimeout(this.timeout);

			this.timeout = setTimeout(() => this.$emit("input", event), 250);
		}
	}
};
</script>

<style lang="scss" scoped>
	.search_bar {
		width: 80%;

		.search-input {
			border-color: #efefef;
			font-size: 1.34rem;
		}

		input::placeholder {
			color: #707070;
			font-weight: bold;
		}

		input:focus {
			outline: none;
		}
	}

	@media screen and (max-width: 1200px) {
		.search_bar {
			.search-input {
				border-color: #efefef;
				font-size: 1.6rem;
			}

			input::placeholder {
				color: #707070;
				font-weight: bold;
			}

			input:focus {
				outline: none;
			}
		}
	}

	@media screen and (max-width: 600px) {
		.search_bar {
			width: 100%;

			.search-input {
				border-color: #efefef;
				font-size: 1.6rem;
			}

			input::placeholder {
				color: #707070;
				font-weight: bold;
			}

			input:focus {
				outline: none;
			}
		}
	}
</style>




